// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__e1PUj","Label":"Input_Label__Ibuon","InputElement":"Input_InputElement__jROBL","Invalid":"Input_Invalid__+pT0D"};